// extracted by mini-css-extract-plugin
module.exports = {"price-widget":"_25b18c","selling-price":"_30jeq3","old-price":"_3I9_wc","discount":"_3Ay6Sb","no-price":"_3utEwz","plus-price":"_3tcB5a","plus-price-applied":"nkBrZ4"};